import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { WhiteSpace, WingBlank, Switch, List, Modal } from "foui";
import styles from "./index.m.scss";
import movable from "../../utils/decorators/movable";
import * as allUrls from "../../router/allUrls";
import utils from "../../utils/utils";
import storeDebugSettings from "../../store/storeDebugSettings";
import { WeinreServerURL } from "../../consts/consts";
import Textarea from "react-textarea-autosize";

function verifyConflict() {
  setTimeout(() => {
    if (storeDebugSettings.weinre && storeDebugSettings.vconsole) {
      storeDebugSettings.clearDebugSettings();
      alert("weinre和vconsole配置冲突, 请重新配置");
      window.location.reload();
    }
  }, 300);
}

@observer
class DebugSettingsItem extends React.Component {
  render() {
    const { keyName } = this.props;
    return (
      <List.Item
        multipleLine
        extra={
          <Switch
            checked={storeDebugSettings[keyName]}
            onChange={v => {
              verifyConflict();
              storeDebugSettings.update({
                [keyName]: v
              });
              utils.toast.info("请刷新页面生效");
            }}
          />
        }
      >
        {this.props.children}
      </List.Item>
    );
  }
}

@movable("DebugFloatIcon-838726", {
  x: 10,
  y: 50
})
@observer
class DebugFloatIconButton extends React.Component {
  render() {
    return (
      <div className="DebugFloatIcon" onClick={this.props.onClick}>
        <img src={require("../../assets/debug/bug@2x.png")} />
      </div>
    );
  }
}

@observer
class DebugFloatIcon extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      debugModalVisible: false
    };
  }
  componentDidMount() {}

  handleClick() {
    // allUrls.urlPageDebugSettings.pushMe();
    this.setState({
      debugModalVisible: !this.state.debugModalVisible
    });
  }
  render() {
    return (
      <div>
        <DebugFloatIconButton onClick={this.handleClick} />
        <Modal
          className="DebugFloatIcon-modal"
          // popup
          // transparent
          closable
          visible={this.state.debugModalVisible}
          onClose={() =>
            this.setState({
              debugModalVisible: false
            })
          }
          animationType="slide-up"
          title="调试配置"
        >
          <WhiteSpace />
          <Textarea
            onClick={() => {
              utils.copyToClipboard(window.location.href);
              utils.toast.info("已复制当前页面的url");
            }}
            className="url-textarea"
            value={window.location.href}
          />
          <WhiteSpace />
          <List>
            <DebugSettingsItem keyName={"jssdkDebug"}>
              开启jssdk的debug模式
            </DebugSettingsItem>
            <DebugSettingsItem keyName={"vconsole"}>
              开启vConsole
              <List.Item.Brief>不要和weinre共用</List.Item.Brief>
            </DebugSettingsItem>
            <DebugSettingsItem keyName={"weinre"}>
              开启weinre远程调试
              <List.Item.Brief>{WeinreServerURL}</List.Item.Brief>
            </DebugSettingsItem>
          </List>
        </Modal>
      </div>
    );
  }
}

DebugFloatIcon.propTypes = {
  // props1: PropTypes.node.isRequired
};
DebugFloatIcon.defaultProps = {
  // props1: undefined
};

export default DebugFloatIcon;



// WEBPACK FOOTER //
// ./src/components/DebugFloatIcon/index.js